import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CargomaticCheckbox from 'components/v2/forms/Checkbox';
import CargomaticModal from 'components/v2/modal';
import { useTranslation } from 'react-i18next';
import { getIsNewFscFlow } from 'utils/FscSettingsApiUtils';

const RerateCostModal = (props) => {
  const { t } = useTranslation();
  const [selectedCosts, setSelectedCosts] = useState([]);
  const [isNewFscFlow, setIsNewFscFlow] = useState(null);

  useEffect(() => {
    (async () => {
      const isNewFscFlow = await getIsNewFscFlow();
      setIsNewFscFlow(isNewFscFlow);
    })();
  }, []);

  const handleCostChange = (changed_cost) => {
    if (selectedCosts.includes(changed_cost)) {
      setSelectedCosts(selectedCosts.filter((el) => el !== changed_cost));
    } else {
      setSelectedCosts((prevState) => {
        return [...prevState, changed_cost];
      });
    }
  };

  const handleRerateShipment = () => {
    props.onRerateCosts(props.shipment, selectedCosts);
    props.onClose();
  };

  const getBody = () => {
    const { shipment } = props;
    const isShipperCostProcessed = !shipment.receivables.find(function (item) {
      return (
        item.type === 'shipper_cost' &&
        item.message === 'Shipper Cost' &&
        !item.processed
      );
    });

    const isShipperFscProcessed = shipment.receivables.find(function (item) {
      return item.type === 'fuel_surcharge' && item.processed;
    });

    const isCarrierCostProcessed = !shipment.payables.find(function (item) {
      return (
        item.type === 'carrier_cost' &&
        item.message === 'Carrier Cost' &&
        !item.processed
      );
    });

    const isCarrierFscProcessed = shipment.payables.find(function (item) {
      return item.type === 'fuel_surcharge' && item.processed;
    });

    return (
      <div className="max-w-sm pb-2 m-3 form-label">
        <h4>{t('SELECT_ITEMS_TO_RERATE')}</h4>
        <CargomaticCheckbox
          id="shipper_cost"
          className="my-3"
          disabled={isShipperCostProcessed}
          checked={selectedCosts.includes('shipper')}
          onChange={() => {
            handleCostChange('shipper');
          }}
        >
          {t('SHIPPER_BASE_COST')}
        </CargomaticCheckbox>
        <CargomaticCheckbox
          id="carrier_cost"
          className="my-3"
          disabled={isCarrierCostProcessed}
          checked={selectedCosts.includes('carrier')}
          onChange={() => {
            handleCostChange('carrier');
          }}
        >
          {t('CARRIER_BASE_COST')}
        </CargomaticCheckbox>

        <CargomaticCheckbox
          id="carrier_fsc"
          className="my-3"
          disabled={isCarrierFscProcessed || !isNewFscFlow}
          checked={selectedCosts.includes('carrier_fsc')}
          onChange={() => {
            handleCostChange('carrier_fsc');
          }}
        >
          {t('CARRIER_FUEL_SURCHARGE')}
        </CargomaticCheckbox>

        <CargomaticCheckbox
          id="shipper_fsc"
          className="my-3"
          disabled={isShipperFscProcessed || !isNewFscFlow}
          checked={selectedCosts.includes('shipper_fsc')}
          onChange={() => {
            handleCostChange('shipper_fsc');
          }}
        >
          {t('SHIPPER_FUEL_SURCHARGE')}
        </CargomaticCheckbox>
      </div>
    );
  };

  const getFooter = () => {
    return (
      <div className="flex justify-end items-center space-x-2">
        <button
          className="button button-green"
          onClick={handleRerateShipment}
          disabled={selectedCosts.length === 0}
        >
          {t('RERATE')}
        </button>
        <button className="button button-secondary" onClick={props.onClose}>
          {t('CANCEL')}
        </button>
      </div>
    );
  };

  return (
    <CargomaticModal
      show={props.show}
      title={t('RERATE_SHIPMENT')}
      body={getBody()}
      footer={getFooter()}
      onHide={props.onClose}
    />
  );
};

RerateCostModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onRerateCosts: PropTypes.func.isRequired,
  shipment: PropTypes.object,
};

export default RerateCostModal;
